/**   
 * 统一权限接口统一管理
 */
import { axiosPost } from './http';

const prexfix = global.$config.api.apiUrl;
// const prexfix = 'https://biaozhunhua.zjht100.com/tsscjk'
// const prexfix = 'http://biaozhunhua.zjht100.com'

// 根据组织部门id获取部门下的人员信息接口
export const findPerUserByOrganizationId = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/permissions-api/permissions/perUser/findPerUserByOrganizationId `, params)
};

// 获取组织树接口
export const findOrganizationTree = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/permissions-api/permissions/perOrganization/findOrganizationTree`, params)
};

// 获取当前登录组织接口
export const findBySysCode = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/permissions-api/permissions/perOrganization/findBySysCode`, params)
};

// 修改密码接口
export const updateUserPasswd = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/permissions-api/permissions/api/per/updateUserPasswd`, params)
};

// 获取权限接口
export const ssoPermission = (data) => {
    const params = {
      baseUrl: prexfix,
      data: data
    }
    return axiosPost(`/permissions-api/permissions/api/per/ssoPermission`, params)
  };

let permissionsApi = {
    findPerUserByOrganizationId,
    findOrganizationTree,
    updateUserPasswd,
    ssoPermission,
    findBySysCode
 };
 
 export default permissionsApi;